<template>
	<div class="pages">
		<navTop></navTop>
		<div class="box">
			<li>
				<span>1、船头照</span>
				<div style="display: flex;" v-if="dataList.sc001">
					<img :src="item" v-for="(item, index) in dataList.sc001.split('|')" />
				</div>

			</li>
			<li>
				<span>2、船尾照</span>
				<div style="display: flex;"  v-if="dataList.sc002">
				<img :src="item" v-for="(item, index) in dataList.sc002.split('|')" />
				</div>
			</li>
			<li>
				<span>3、合照（现场检验员和船舶）</span>
				<div style="display: flex;"  v-if="dataList.sc003">
				<img :src="item" v-for="(item, index) in dataList.sc003.split('|')" />
				</div>
			</li>
			<li>
				<span>4、工作中的照片</span>
				<div style="display: flex;"  v-if="dataList.sc004">
				<img :src="item" v-for="(item, index) in dataList.sc004.split('|')" />
				</div>
			</li>
			<li>
				<span>5、Report No.</span>
				<span>{{ dataList.sc005 }}</span>
			</li>
			<li>
				<span>6、Port:</span>
				<span>{{ dataList.sc006 }}</span>
			</li>
			<li>
				<span>7、Vessel name</span>
				<span>{{ dataList.sc007 }}</span>
			</li>
			<li>
				<span>8、Prot of Registry</span>
				<span>{{ dataList.sc008 }}</span>
			</li>
			<li>
				<span>9、IMO No</span>
				<span>{{ dataList.sc009 }}</span>
			</li>
			<li>
				<span>10、</span>
				<span>{{ dataList.sc010 }}</span>
			</li>
			<li>
				<span>11、Kind of Ship</span>
				<span>{{ dataList.sc011 }}</span>
			</li>
			<li>
				<span>12、Gross/Net Tonnage</span>
				<span>{{ dataList.sc012 }}</span>
			</li>
			<li>
				<span>13、Deadweight(Summer)</span>
				<span>{{ dataList.sc013 }}</span>
			</li>
			<li>
				<span>14、LOA/Breadth/Depth(M)</span>
				<span>{{ dataList.sc014 }}</span>
			</li>
			<li>
				<span>15、BILL Quantity</span>
				<span>{{ dataList.sc015 }}</span>
			</li>
			<li>
				<span>16、B/L No.</span>
				<span>{{ dataList.sc016 }}</span>
			</li>
			<li>
				<span>17、Shipper</span>
				<span>{{ dataList.sc017 }}</span>
			</li>
			<li>
				<span>18、Consignee</span>
				<span>{{ dataList.sc018 }}</span>
			</li>
			<li>
				<span>19、Notify</span>
				<span>{{ dataList.sc019 }}</span>
			</li>
			<li>
				<span>20、Loading Port</span>
				<span>{{ dataList.sc020 }}</span>
			</li>
			<li>
				<span>21、Discharge Port</span>
				<span>{{ dataList.sc021 }}</span>
			</li>
			<li>
				<span>22、Commodity</span>
				<span>{{ dataList.sc022 }}</span>
			</li>
			<li>
				<span>23、On board time</span>
				<span>{{ dataList.sc023 }}</span>
			</li>
			<li>
				<span>24、Berth time</span>
				<span>{{ dataList.sc024 }}</span>
			</li>
			<li>
				<span>25、Discharging plan</span>
				<span>{{ dataList.sc0251 }}</span>
			</li>

			<li>
				<span>26、初尺时间</span>
				<span>{{ dataList.sc026 }}-{{dataList.sc02601}}</span>
			</li>
			<li>
				<span>27、开工时间</span>
				<span>{{ dataList.sc027 }}</span>
			</li>
			<li>
				<span>28、Stowage plan（上传图片）</span>
				<div style="display: flex;"  v-if="dataList.sc028">
				<img :src="item" v-for="(item, index) in dataList.sc028.split('|')" />
				</div>
			</li>
			<li>
				<span>29、BILL （上传图片）</span>
				<div style="display: flex;"  v-if="dataList.sc029">
				<img :src="item" v-for="(item, index) in dataList.sc029.split('|')" />
				</div>
			</li>
			<li>
				<span>30、Ship’s Particular （上传图片）</span>
				<div style="display: flex;"  v-if="dataList.sc030">
				<img :src="item" v-for="(item, index) in dataList.sc030.split('|')" />
				</div>
			</li>
			<li>
				<span>31、Crew list（上传图片）</span>
				<div style="display: flex;"  v-if="dataList.sc031">
				<img :src="item" v-for="(item, index) in dataList.sc031.split('|')" />
				</div>
			</li>
			<p>末尺</p>
			<li>
				<span>1、合照（现场检验员和船舶）</span>
				<img :src="dataList.sc1001" />
			</li>
			<li>
				<span>2、工作中的照片</span>
				<img :src="dataList.sc1002" />
			</li>
			<li>
				<span>3、完工时间</span>
				<span>{{ dataList.sc1003 }}</span>
			</li>
			<li>
				<span>4、末尺时间</span>
				<span>{{ dataList.sc1004 }}</span>
			</li>
			<li>
				<span>5、水尺数量</span>
				<span>{{ dataList.sc1005 }}</span>
			</li>
			<li>
				<span>6、difference to stowage plan</span>
				<span>{{ dataList.sc1006 }}</span>
			</li>
			<li>
				<span>7、上传电子签名</span>
				<img :src="dataList.sc1007" />
			</li>
			<li>
				<span>8、上传证书图片</span>
				<img :src="dataList.sc1008" />
			</li>
			<li>
				<span>9、上传报告</span>
				<pdf v-if="num == 1" ref="pdf" :src="dataList.sc1010"></pdf>
				<img v-if="num == 0" :src="dataList.sc1010" />
			</li>
		</div>
	</div>
</template>

<script>
import navTop from '../../components/navTop.vue';
import pdf from 'vue-pdf';
export default {
	name: 'sc',
	components: {
		navTop,
		pdf
	},
	data() {
		return {
			dataList: {},
			num: ''
		};
	},
	created() {
		if (!sessionStorage.getItem('uid')) {
			this.$router.push({ path: '/' });
		} else {
			this.id = this.$route.query.id;
			this.getSchedulesc();
		}
	},
	methods: {
		getSchedulesc() {
			let data = {
				id: this.id
			};
			this.$api.schedulesc(data).then(res => {
				console.log(res);
				if (res.result == 0) {
					this.dataList = res.data;
					if (res.data.sc1010) {
						if (this.getSuffix(res.data.sc1010) == 'pdf') {
							this.num = 1;
						} else {
							this.num = 0;
						}
					}
				}
			});
		},
		// 截取后缀名
		getSuffix(str) {
			var index = str.lastIndexOf('.');
			return str.substr(index + 1);
		}
	}
};
</script>

<style lang="scss" scoped>
.pages {
	background: #3E414A;
	.box {
		margin: 50px auto;
		border: 1px solid rgba(0, 255, 255, 0.25);
		border-radius: 10px;
		padding: 45px 154px 38px 56px;
		box-sizing: border-box;
		box-shadow: 0 0 300px 100px #043138 inset;
		li {
			display: flex;
			flex-direction: column;
			padding-bottom: 20px;
			box-sizing: border-box;
			span:nth-child(1) {
				color: #00fff0;
				font-size: 24px;
				line-height: 1em;
			}
			span:nth-child(2) {
				font-size: 24px;
				color: #ffffff;
				line-height: 1em;
				padding-top: 15px;
				box-sizing: border-box;
			}
			a {
				font-size: 24px;
				color: #ffffff;
				line-height: 1em;
				padding-top: 15px;
				box-sizing: border-box;
			}
			img {
				margin-top: 15px;
				display: block;
				width: 392px;
				height: 292px;
				border-radius: 10px;
			}
		}
	}
}
</style>
